import React from 'react';
import { Link } from 'react-router-dom';

const CookiesPolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">&larr; Volver al inicio</Link>
        <h1 className="legal-title">Pol&iacute;tica de Cookies</h1>
        <p className="legal-date">
          <em>&Uacute;ltima actualizaci&oacute;n: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</em>
        </p>

        <section className="legal-section">
          <h2>1. &iquest;Qu&eacute; son las cookies?</h2>
          <p>
            Las cookies son peque&ntilde;os archivos de texto que se almacenan en su dispositivo (ordenador,
            tablet o m&oacute;vil) cuando visita un sitio web. Sirven para que el sitio web recuerde
            informaci&oacute;n sobre su visita, como sus preferencias, lo que puede facilitar su pr&oacute;xima
            visita y hacer que el sitio le resulte m&aacute;s &uacute;til.
          </p>
          <p>
            Adem&aacute;s de cookies, este sitio web utiliza otras tecnolog&iacute;as de almacenamiento local
            como <strong>localStorage</strong>, que permite guardar datos en su navegador de forma persistente.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. &iquest;Qui&eacute;n es el responsable del uso de cookies en este sitio web?</h2>
          <p>
            El responsable del uso de cookies es <strong>Myntar S.L. PENDIENTE NIF</strong> (en
            adelante, &ldquo;Myntar&rdquo;), con domicilio en C&oacute;rdoba, Espa&ntilde;a.
          </p>
          <p>
            Email de contacto: <strong>contact@myntar.tech</strong>
          </p>
        </section>

        <section className="legal-section">
          <h2>3. &iquest;Qu&eacute; tipos de cookies utilizamos?</h2>

          <h3>3.1 Cookies t&eacute;cnicas / necesarias</h3>
          <p>
            Son aquellas que permiten al usuario la navegaci&oacute;n a trav&eacute;s del sitio web y la
            utilizaci&oacute;n de las diferentes opciones que en &eacute;l existen.
          </p>
          <div className="legal-table-wrapper">
            <table className="legal-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Tipo</th>
                  <th>Finalidad</th>
                  <th>Duraci&oacute;n</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>cookiesAccepted</code></td>
                  <td>localStorage</td>
                  <td>Registrar si el usuario ha aceptado la pol&iacute;tica de cookies</td>
                  <td>Persistente</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3>3.2 Cookies de preferencias / personalizaci&oacute;n</h3>
          <p>
            Permiten recordar informaci&oacute;n para que el usuario acceda al sitio web con determinadas
            caracter&iacute;sticas que pueden diferenciar su experiencia de la de otros usuarios.
          </p>
          <div className="legal-table-wrapper">
            <table className="legal-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Tipo</th>
                  <th>Finalidad</th>
                  <th>Duraci&oacute;n</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>theme</code></td>
                  <td>localStorage</td>
                  <td>Guardar la preferencia de tema visual (claro/oscuro) del usuario</td>
                  <td>Persistente</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3>3.3 Cookies de terceros</h3>
          <p>
            Este sitio web utiliza el servicio <strong>EmailJS</strong> para el env&iacute;o de formularios
            de contacto. EmailJS puede utilizar cookies t&eacute;cnicas necesarias para el funcionamiento
            del servicio de env&iacute;o de correos electr&oacute;nicos.
          </p>
          <p>
            Puede consultar la pol&iacute;tica de privacidad de EmailJS en:&nbsp;
            <a href="https://www.emailjs.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer">
              www.emailjs.com/legal/privacy-policy
            </a>
          </p>

          <h3>3.4 Cookies y almacenamiento del avatar interactivo</h3>
          <p>
            El avatar interactivo utiliza almacenamiento local para gestionar sesiones de conversaci&oacute;n:
          </p>
          <div className="legal-table-wrapper">
            <table className="legal-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Tipo</th>
                  <th>Finalidad</th>
                  <th>Duraci&oacute;n</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>avatarInfoSeen</code></td>
                  <td>localStorage</td>
                  <td>Registrar que el usuario ha sido informado sobre el procesamiento de datos del avatar</td>
                  <td>Persistente</td>
                </tr>
                <tr>
                  <td><code>sessionId</code></td>
                  <td>sessionStorage</td>
                  <td>Identificador &uacute;nico de sesi&oacute;n de conversaci&oacute;n</td>
                  <td>Sesi&oacute;n del navegador</td>
                </tr>
                <tr>
                  <td><code>deviceId</code></td>
                  <td>localStorage</td>
                  <td>Identificador pseud&oacute;nimo del dispositivo para analytics</td>
                  <td>Persistente</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3>3.5 Proveedores externos del avatar</h3>
          <p>
            El avatar interactivo utiliza los siguientes servicios de terceros que pueden establecer
            sus propias cookies t&eacute;cnicas:
          </p>
          <ul>
            <li><strong>Lemonfox:</strong> Servicio de transcripci&oacute;n de voz a texto</li>
            <li><strong>OpenAI:</strong> Modelo de lenguaje para generaci&oacute;n de respuestas
            (<a href="https://openai.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer">Pol&iacute;tica de privacidad</a>)</li>
            <li><strong>ElevenLabs / Google Cloud TTS:</strong> S&iacute;ntesis de voz
            (<a href="https://elevenlabs.io/privacy" target="_blank" rel="noopener noreferrer">Pol&iacute;tica de privacidad de ElevenLabs</a>)</li>
            <li><strong>IPLocate:</strong> Servicio de geolocalizaci&oacute;n por IP</li>
          </ul>
          <p>
            Puede consultar las pol&iacute;ticas de privacidad de estos proveedores en sus respectivos sitios web.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Cookies anal&iacute;ticas y de marketing</h2>
          <p>
            Actualmente, este sitio web <strong>no utiliza</strong> cookies anal&iacute;ticas (como Google
            Analytics) ni cookies de marketing o publicidad. No se realiza ning&uacute;n tipo de seguimiento
            o perfilado del usuario con fines publicitarios.
          </p>
          <p>
            En caso de que en el futuro se implementen este tipo de cookies, se actualizar&aacute; esta
            pol&iacute;tica y se solicitar&aacute; el consentimiento previo del usuario.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. &iquest;C&oacute;mo puede gestionar las cookies?</h2>
          <p>
            Usted puede permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la
            configuraci&oacute;n de las opciones de su navegador de Internet. A continuaci&oacute;n le
            indicamos los enlaces donde encontrar&aacute; informaci&oacute;n sobre c&oacute;mo gestionar
            las cookies en los principales navegadores:
          </p>
          <ul>
            <li><strong>Google Chrome:</strong> Configuraci&oacute;n &rarr; Privacidad y seguridad &rarr; Cookies y otros datos de sitios</li>
            <li><strong>Mozilla Firefox:</strong> Opciones &rarr; Privacidad y seguridad &rarr; Cookies y datos del sitio</li>
            <li><strong>Safari:</strong> Preferencias &rarr; Privacidad &rarr; Cookies y datos de sitios web</li>
            <li><strong>Microsoft Edge:</strong> Configuraci&oacute;n &rarr; Cookies y permisos del sitio &rarr; Cookies y datos almacenados</li>
          </ul>
          <p>
            Para eliminar los datos de <strong>localStorage</strong> utilizados por este sitio, puede acceder
            a las herramientas de desarrollo de su navegador (generalmente con la tecla F12) y borrar
            los datos de almacenamiento local del dominio myntar.tech.
          </p>
          <p>
            Tenga en cuenta que si desactiva o elimina las cookies, es posible que algunas funcionalidades
            del sitio web no est&eacute;n disponibles o no funcionen correctamente (por ejemplo, la
            preferencia de tema visual).
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Base legal para el uso de cookies</h2>
          <p>
            La base legal para el uso de cookies t&eacute;cnicas necesarias es el inter&eacute;s leg&iacute;timo
            del responsable del sitio web (art&iacute;culo 6.1.f del RGPD), ya que son imprescindibles para
            el correcto funcionamiento del sitio.
          </p>
          <p>
            Para las cookies de preferencias, la base legal es el <strong>consentimiento del usuario</strong>
            (art&iacute;culo 6.1.a del RGPD y art&iacute;culo 22.2 de la LSSI-CE), que se recaba a trav&eacute;s
            del banner de cookies mostrado en la primera visita.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Sus derechos</h2>
          <p>
            De acuerdo con el Reglamento General de Protecci&oacute;n de Datos (RGPD) y la Ley Org&aacute;nica
            3/2018 de Protecci&oacute;n de Datos y Garant&iacute;a de los Derechos Digitales (LOPD-GDD),
            usted tiene derecho a:
          </p>
          <ul>
            <li>Ser informado sobre el uso de cookies</li>
            <li>Prestar o retirar su consentimiento en cualquier momento</li>
            <li>Solicitar acceso, rectificaci&oacute;n o supresi&oacute;n de sus datos</li>
            <li>Presentar una reclamaci&oacute;n ante la Agencia Espa&ntilde;ola de Protecci&oacute;n de
            Datos (<strong>www.aepd.es</strong>) si considera que sus derechos no han sido respetados</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>8. Actualizaciones de esta pol&iacute;tica</h2>
          <p>
            Myntar se reserva el derecho de modificar esta Pol&iacute;tica de Cookies en cualquier momento
            para adaptarla a novedades legislativas, jurisprudenciales o a pr&aacute;cticas del sector.
            Cualquier cambio sustancial ser&aacute; comunicado a los usuarios a trav&eacute;s de este sitio web.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Contacto</h2>
          <p>
            Si tiene alguna pregunta sobre esta Pol&iacute;tica de Cookies, puede contactarnos en:
          </p>
          <p>
            <strong>Email:</strong> contact@myntar.tech<br />
            <strong>Direcci&oacute;n:</strong> C&oacute;rdoba, Espa&ntilde;a
          </p>
        </section>

        <div className="legal-links-section">
          <p>Ver tambi&eacute;n:</p>
          <ul>
            <li><Link to="/privacidad">Pol&iacute;tica de Privacidad</Link></li>
            <li><Link to="/aviso-legal">Aviso Legal</Link></li>
            <li><Link to="/terminos">T&eacute;rminos y Condiciones</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CookiesPolicy;
